import { MetadataType } from '@aibees/elephant/hooks';
import { capitalize } from '@aibees/shared/utils';
import { FundingTypeLabelParser } from '../components/filter-tags/utils';
import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';
import { FUNDING_TYPE_FILTER_OPTIONS } from './funding-types';

export default function fundingFilterConfig(): SearchFilterBase {
  return {
    name: 'Funding',
    icon: 'account-balance',
    index: 12,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    sections: { main: 2, more: 0 },
    items: [
      {
        name: 'Funding Type',
        type: SearchFilterType.NONE,
        icon: undefined,
        index: 0,
        key: '',
        field: '',
        metadata: {
          color: 'primary',
        },
        utils: {
          tags: {
            config: {
              showAsCard: true,
              tagsCardTitle: 'Funding Type',
            },
          },
        },
        config: { labelKey: 'label', valueKey: 'value' },
        nested: true,
        open: true,
        items: [
          {
            name: 'Funding Type',
            type: SearchFilterType.CUSTOM_SELECT_TREE,
            icon: undefined,
            index: 0,
            key: 'funding_type',
            field: 'funding_type',
            nested: true,
            open: true,
            layer: 4,
            metadata: {
              color: 'primary',
              placeholder: 'Enter Funding Types (OR) Search',
              autocomplete: {
                recent: false,
                checkboxPosition: 'right',
                multiple: true,
                customOptions: true,
              },
              metaDataApi: {
                enabled: true,
                key: MetadataType.COMPANY_FUNDING_TYPE,
              },
            },
            searchKey: 'value',
            config: { labelKey: 'label', valueKey: 'value' },
            utils: {
              tags: { labelFormatter: FundingTypeLabelParser },
            },
            treeOptions: FUNDING_TYPE_FILTER_OPTIONS,
          },
        ],
      },
      {
        name: '',
        type: SearchFilterType.RADIO_GROUP,
        icon: undefined,
        index: 1,
        key: '',
        field: '',
        metadata: {},
        sections: { main: 1, more: 3 },
        config: { labelKey: 'label', valueKey: 'value' },
        utils: {
          tags: {
            config: {
              showAsCard: true,
              tagsCardTitle: 'All Funded Companies',
            },
          },
        },
        items: [
          {
            name: 'All Funded Companies',
            type: SearchFilterType.NONE,
            icon: undefined,
            index: 0,
            key: 'all_funded',
            field: 'all_funded',
            metadata: { color: 'primary' },
            open: true,
            layer: 4,
            items: [
              {
                name: 'Last Funding Round Date',
                type: SearchFilterType.DATE_RANGE,
                index: 0,
                key: 'all_funded_last_raised_at',
                field: 'all_funded_last_raised_at',
                metadata: { color: 'primary' },
                options: [],
                nested: true,
              },
              {
                name: 'Last Funding Round Amount',
                type: SearchFilterType.NUMBER_RANGE,
                index: 1,
                key: 'all_funded_latest_funding_amount',
                field: 'all_funded_latest_funding_amount',
                metadata: { color: 'primary', icon: 'dollar' },
                nested: true,
              },
              {
                name: 'Total Funding Amount',
                type: SearchFilterType.NUMBER_RANGE,
                index: 2,
                key: 'all_funded_total_funding_amount',
                field: 'all_funded_total_funding_amount',
                metadata: { color: 'primary', icon: 'dollar' },
                nested: true,
              },
            ],
          },
          {
            name: 'No Funding Received',
            type: SearchFilterType.NOT_AVAILABLE,
            icon: undefined,
            index: 3,
            key: 'funding_availability',
            field: 'funding_availability',
            metadata: {
              color: 'primary',
            },
            utils: {
              tags: {
                labelFormatter: (value: string) =>
                  capitalize(value.replace('_', ' ')),
              },
            },
          },
        ],
      },
    ],
  };
}
